<template>
  <b-card-text class="drop-area">
    <container-loader v-if="!loaded"></container-loader>
    <PartialRenderer v-else :items="projectsList" force-render-items="50" step="20" v-slot="{item, index}">
      <project-item :project="item" :force-show-files="showFirstProjectFiles && index === 0"></project-item>
    </PartialRenderer>
  </b-card-text>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import ProjectItem from "./ProjectItem";
  import PartialRenderer from "../PartialRenderer";
  export default {
    name: "ProjectsTab",
    components: {
      PartialRenderer,
      ProjectItem
    },
    computed: {
      ...mapGetters(['sortedProjects', 'getFilesByProjectId']),

      projectsList() {
        if (!this.loaded) {
          return [];
        }
        if (!this.search || !this.search.trim()) {
          return this.sortedProjects;
        }
        const searchString = this.search.toLowerCase();
        return this.sortedProjects.filter(project => {
          if (project.name.toLowerCase().indexOf(searchString) >= 0) {
            return true;
          } else {
            const files = this.getFilesByProjectId(project.id);
            if (files.length) {
              for (let i in files) {
                if (files[i].filename.toLowerCase().indexOf(searchString) >= 0) {
                  return true;
                }
              }
            }
          }
          return false;
        });
      }
    },
    props: {
      showFirstProjectFiles: {
        type: Boolean,
        default: true
      },
      search: {
        type: String
      }
    },
    data() {
      return {
        polling: null,
        loaded: false
      }
    },
    methods:{
      ...mapActions(['fetchProjects', 'searchProjectsFiles'])
    },
    created() {
      this.fetchProjects().then(() => this.loaded = true);
      this.polling = setInterval(() => {
        this.fetchProjects();
      }, 3000);
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    watch: {
      search: function(newVal) {
        if (newVal && newVal.trim()) {
          this.loaded = false;
          this.searchProjectsFiles(newVal).then(() => {
            this.loaded = true;
          }).catch(() => {
            this.loaded = true;
          });
        }
      }
    }
  }
</script>
